import IVendorConfig from "src/environments/Ivendor-config";

export function bluumMapper(config: IVendorConfig) {
    config.primaryUseOptionsToDisplay = ["Education"];
    config.subscriptionLicenses = [
      {
        name: "Annual",
        value: 6634316
      },
      {
        name: "Annual-Monthly",
        value: 5556220
      },
      {
        name: "None",
        value: 0
      }
    ];
    config.needToRunOptionsToDisplayEnterprise = [
      "Web Browsing & Single Tasks",
      "Video Conferencing",
      "Web Productivity Apps",
      "Android Apps",
      "Virtualization"
    ];

    config.brandsOptionsToDisplay = [
      "Lenovo",
      "Acer",
      "ASUS",
      "HP"
    ];
}
